import {
  Reduction_Reductions as reductionQuery,
  Reduction_CreatePercentageReduction as newPercReductionCmd,
  Reduction_CreateFixedReduction as newFixedReductionCmd,
  Reduction_DeleteReduction as deleteReductionCmd,
  Reduction_CreateUniqueFixedReductions as fixedTans,
  Reduction_CreateUniquePercentageReductions as percentageTans,
} from './backend'

const getReductions = async (page, pageSize, sortBy, text, code) => {
  let {data} = await reductionQuery({
    sortBy: sortBy,
    page: page,
    pageSize: pageSize,
    text: text,
    code: code,
  })
  return data
}

const createPercentageReduction = async cmd => {
  let {data} = await newPercReductionCmd({
    cmd: cmd,
  })
  return data
}

const createFixedReduction = async cmd => {
  let {data} = await newFixedReductionCmd({
    cmd: cmd,
  })
  return data
}

const createPercentageTanReductions = async cmd => {
  let {data} = await percentageTans({
    cmd: cmd,
  })
  return data
}

const createFixedTanReductions = async cmd => {
  let {data} = await fixedTans({
    cmd: cmd,
  })
  return data
}

const deleteReduction = async id => {
  let {data} = await deleteReductionCmd({
    cmd: {
      id: id,
    },
  })
  return data
}

export default {
  getReductions,
  createPercentageReduction,
  createFixedReduction,
  deleteReduction,
  createPercentageTanReductions,
  createFixedTanReductions,
}
